import React from "react";
import {useTranslation} from "react-i18next";

interface Props {
    status?: string;
    matchingStatus?: unknown;
}

const LogStatusBadge = ({status = "", matchingStatus}: Props) => {
    const {t} = useTranslation();
    const normalizedStatus = status.toLowerCase();
    const normalizedMatchingStatus = typeof matchingStatus === "string" ? matchingStatus : "";
    const matchingLabels: Record<string, string> = {
        pending: t("log.pending"),
        pending_invoice: t("log.pending_invoice"),
        booked: t("log.booked"),
        matched: t("log.matched"),
        no_exist: t("log.no_exist"),
    };
    const matchingClasses: Record<string, string> = {
        pending: "bg-warning text-dark",
        pending_invoice: "bg-warning text-dark",
        booked: "bg-info text-dark",
        matched: "bg-success",
        no_exist: "bg-danger",
    };
    const statusLabel =
        normalizedStatus === "success"
            ? t("log.success")
            : normalizedStatus === "error"
                ? t("log.error")
                : normalizedStatus === "notice"
                    ? t("log.notice")
                    : status || t("log.unknown");
    const statusClass =
        normalizedStatus === "success"
            ? "bg-success"
            : normalizedStatus === "error"
                ? "bg-danger"
                : normalizedStatus === "notice"
                    ? "bg-info text-dark"
                    : "bg-secondary";

    const matchingLabel = matchingLabels[normalizedMatchingStatus];
    const matchingClass = matchingClasses[normalizedMatchingStatus];

    // Waiting states are not hard failures — prefer matching badge.
    if (matchingLabel && matchingClass) {
        return (
            <span className="d-inline-flex flex-wrap gap-1 align-items-center">
                <span className={`badge ${matchingClass}`}>{matchingLabel}</span>
                {normalizedStatus === "error" && normalizedMatchingStatus !== "pending_invoice" && (
                    <span className={`badge ${statusClass}`}>{statusLabel}</span>
                )}
            </span>
        );
    }

    return <span className={`badge ${statusClass}`}>{statusLabel}</span>;
};

export default React.memo(LogStatusBadge);
